import React from "react";
import { useNavigate, type NavigateOptions } from "react-router-dom";
import { withPersistentParams } from "@/utils/urlParams";

// useNavigate that keeps ?agent= and ?wl= in the URL on every step.
export const useFunnelNavigate = () => {
  const navigate = useNavigate();
  return React.useCallback(
    (to: string, options?: NavigateOptions) => navigate(withPersistentParams(to), options),
    [navigate]
  );
};
